export default "__VITE_ASSET__495a3da4__"